/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import React, { useState } from 'react';
import styled from 'styled-components';
import Colors from 'constants/Colors';

export default function Tabs({ tabs }) {
  const [activeTab, setActiveTab] = useState(0);

  const Tab = styled.div`
    position: relative;
    z-index: 99;
    margin-bottom: -2px;
    display: inline-block;
    padding: 10px 20px;
    cursor: pointer;
    background-color: ${({ active }) => active ? "#fff" : "#3A5DAE"};
    border: 2px solid #3A5DAE;
    border-bottom: ${({ active }) => active ? "#fff" : "#3A5DAE"};
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: ${({ active }) => active ? "#53565A" : "#fff"};
    &:hover {
      filter: brightness(1.1);
    }
  `;

  return (
    <>
      <div style={{
        display: "flex",
        marginLeft: "24px",
        gap: "4px"
      }}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            onClick={() => setActiveTab(index)}
            active={activeTab === index}
          >
            {tab.label}
          </Tab>
        ))}
      </div>
      <div
        style={{
          padding: "20px",
          border: "2px solid #3A5DAE",
          borderRadius: "20px",
          backgroundColor: "#fff",
          marginBottom: "50px",
        }}
      >
        {tabs.find((tab, index) => index === activeTab)?.content}
      </div>
    </>
  );
}